import { Icon } from "@iconify/react/dist/iconify.js";

const EditUserModal = ({ 
    isOpen, 
    onClose, 
    editEmail, 
    setEditEmail, 
    editName, 
    setEditName, 
    editRole, 
    setEditRole, 
    roles, 
    onSave 
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-background p-4 rounded-lg w-1/3">
                <h2 className="text-xl mb-4">Edit User</h2>
                <div className="flex flex-col gap-4">
                    <input
                        type="text"
                        value={editEmail}
                        onChange={(e) => setEditEmail(e.target.value)}
                        placeholder="Email"
                        className="p-2 rounded input-textbox"
                    />
                    <input
                        type="text"
                        value={editName}
                        onChange={(e) => setEditName(e.target.value)}
                        placeholder="Name"
                        className="p-2 rounded input-textbox"
                    />
                    <select
                        value={editRole}
                        onChange={(e) => setEditRole(e.target.value)}
                        className="p-2 rounded input-textbox"
                    >
                        <option value="">Select Role</option>
                        {roles.map(role => (
                            <option key={role.id} value={role.id}>{role.name}</option>
                        ))}
                    </select>
                    <div className="flex gap-2 justify-end">
                        <button
                            onClick={onClose}
                            className="p-2 bg-gray-500 text-white rounded button-container"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onSave}
                            className="p-2 bg-blue-500 text-white rounded button-container"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditUserModal;
